import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const api = {
  // venues
  listVenues: (params = {}) => client.get("/venues", { params }).then((r) => r.data),
  getVenue: (id) => client.get(`/venues/${id}`).then((r) => r.data),
  // reviews
  listReviews: (id) => client.get(`/venues/${id}/reviews`).then((r) => r.data),
  addReview: (id, payload) => client.post(`/venues/${id}/reviews`, payload).then((r) => r.data),
  markHelpful: (reviewId, deviceId) => client.post(`/reviews/${reviewId}/helpful`, { device_id: deviceId }).then((r) => r.data),
  deleteReviewAdmin: (reviewId) =>
    client.delete(`/admin/reviews/${reviewId}`, { headers: authHeader() }).then((r) => r.data),
  // end-user registration
  registerUser: (payload) => client.post("/users/register", payload).then((r) => r.data),
  // activity feed (public, powered by reviews)
  activityFeed: (limit = 50) =>
    client.get(`/activity/feed`, { params: { limit } }).then((r) => r.data),
  // coupons
  listCoupons: (params = {}) => client.get("/coupons", { params }).then((r) => r.data),
  getCoupon: (id) => client.get(`/coupons/${id}`).then((r) => r.data),
  claimCoupon: (id, payload = {}) =>
    client
      .post(`/coupons/${id}/claim`, { ...payload, device_id: payload.device_id || storage.getDeviceId() })
      .then((r) => r.data),
  getClaimed: (id) => client.get(`/claimed-coupons/${id}`).then((r) => r.data),
  redeemCoupon: (claim_code) => client.post(`/coupons/redeem`, { claim_code }).then((r) => r.data),
  // routes
  listRoutes: (params = {}) => client.get("/routes", { params }).then((r) => r.data),
  getRoute: (id) => client.get(`/routes/${id}`).then((r) => r.data),
  createRoute: (payload) => client.post("/routes", payload).then((r) => r.data),
  // stats
  stats: () => client.get("/stats").then((r) => r.data),
};

// Admin token detection — visible to the browser via localStorage after /admin/login.
// Used to gate the review "Eliminar" button in public pages.
function authHeader() {
  const t = localStorage.getItem("kiltro_admin_token");
  return t ? { Authorization: `Bearer ${t}` } : {};
}

export function hasAdminToken() {
  const t = localStorage.getItem("kiltro_admin_token");
  if (!t) return false;
  // Best-effort JWT expiry check (client-side only; server is source of truth).
  try {
    const [, payload] = t.split(".");
    const decoded = JSON.parse(atob(payload.replace(/-/g, "+").replace(/_/g, "/")));
    if (decoded?.exp && decoded.exp * 1000 < Date.now()) return false;
  } catch { /* ignore decoding errors, let server validate */ }
  return true;
}

// LocalStorage helpers for "mis cupones"
export const storage = {
  getClaimed: () => {
    try {
      return JSON.parse(localStorage.getItem("kiltro_claimed") || "[]");
    } catch {
      return [];
    }
  },
  saveClaimed: (claim) => {
    const list = storage.getClaimed();
    list.unshift({
      id: claim.id,
      coupon_id: claim.coupon_id,
      venue_name: claim.venue_name,
      title: claim.title,
      discount: claim.discount,
      claim_code: claim.claim_code,
      claimed_at: claim.claimed_at,
    });
    localStorage.setItem("kiltro_claimed", JSON.stringify(list.slice(0, 50)));
  },
  isClaimed: (coupon_id) => {
    return storage.getClaimed().some((c) => c.coupon_id === coupon_id);
  },
  getHandle: () => localStorage.getItem("kiltro_handle") || "",
  setHandle: (h) => localStorage.setItem("kiltro_handle", h),
  // End-user session (email-based). Persisted per device.
  getUserId: () => localStorage.getItem("kiltro_user_id") || "",
  getUserNickname: () => localStorage.getItem("kiltro_user_nickname") || "",
  getUserEmail: () => localStorage.getItem("kiltro_user_email") || "",
  setUserSession: ({ user_id, nickname, email }) => {
    if (user_id) localStorage.setItem("kiltro_user_id", user_id);
    if (nickname) {
      localStorage.setItem("kiltro_user_nickname", nickname);
      localStorage.setItem("kiltro_handle", nickname); // keep legacy handle in sync
    }
    if (email) localStorage.setItem("kiltro_user_email", email);
  },
  clearUserSession: () => {
    localStorage.removeItem("kiltro_user_id");
    localStorage.removeItem("kiltro_user_nickname");
    localStorage.removeItem("kiltro_user_email");
  },
  getDeviceId: () => {
    let id = localStorage.getItem("kiltro_device_id");
    if (!id) {
      id = (crypto?.randomUUID?.() || `dev-${Date.now()}-${Math.random().toString(36).slice(2)}`);
      localStorage.setItem("kiltro_device_id", id);
    }
    return id;
  },
  getHelpfulMarks: () => {
    try {
      return new Set(JSON.parse(localStorage.getItem("kiltro_helpful") || "[]"));
    } catch {
      return new Set();
    }
  },
  toggleHelpfulMark: (reviewId) => {
    const set = storage.getHelpfulMarks();
    if (set.has(reviewId)) set.delete(reviewId);
    else set.add(reviewId);
    localStorage.setItem("kiltro_helpful", JSON.stringify([...set]));
  },
};
